module.exports = __webpack_public_path__ + "img/asterisk-02.2c54aca5.svg";